import { NotificationService } from "@notification/notification.service";

export class DocumentViewBase {
  documentInfo: any = {};

  currentPage: any;

  currentPageStyle: any = {};

  currentPageIdx = 0;

  canvasPages: any[] = [];

  constructor(public notificationService: NotificationService) { }

  beforeLoadPage(newPageIndex: number) {
  }

  storeBeforeLoadPage(newPageIndex: number) { }

  loadPageSetData(pageIndex: number) { }

  loadPage(pageIndex: Event|number) {
    this.updatePageData(pageIndex as number);
    this.currentPageIdx = pageIndex as number;
  }

  updatePageData(pageIndex: number) {

    this.beforeLoadPage(pageIndex);

    if (Array.isArray(this.documentInfo?.pages) &&
      pageIndex >= 0 && pageIndex < this.documentInfo.pages.length) {

      this.storeBeforeLoadPage(pageIndex);

      this.currentPage = this.documentInfo.pages[pageIndex];

      const unit = this.currentPage.unit;

      this.currentPageStyle = {
        'width': this.currentPage.width + unit,
        'height': this.currentPage.height + unit,
      };

      this.loadPageSetData(pageIndex);
    }
  }

  setDocumentInfo(info: any) {
    if (!info?.result.success) {
      this.notificationService.showErrors([
        'Dokumentinformation konnte nicht gelesen werden. Editieren nicht möglich.'
      ]);
      return;
    }
    this.documentInfo = info.result;

    if (this.documentInfo.pages?.length > 0) {
      this.loadPage(0);
    }
  }
}
